import React from "react";
import { useReveal } from "../hooks/useReveal";

export function Reveal({ children, delay = 0, className = "" }) {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(28px)",
        transition: `opacity 0.8s ease ${delay}s, transform 0.8s cubic-bezier(.16,.84,.44,1) ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}

export default Reveal;
